import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Alert, Box } from "@mui/material";
import MetalRateGrid, {
  buildCountryNameMap,
  dateColumn,
  filterMetalRateRows,
  withCountryName,
  countryColumn,
  karatColumn,
  metalNameColumn,
  purityColumn,
  ratePerGramColumn,
  rateTypeColumn,
  rateWithGstColumn,
  stateColumn,
  taxColumn,
  updatedByColumn,
} from "./MetalRateGrid";

const MetalRateSellTable = ({ title = "Current Sell Metal Rates" }) => {
  const { sellRateList, buyRateList, metals, loading, error } = useSelector(
    (state) => state.metalRate,
  );
  const taxType = useSelector(
    (state) => state?.appConfig?.configData?.taxtype || "GST",
  );

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const rows = useMemo(() => {
    const countryNames = buildCountryNameMap(
      sellRateList,
      buyRateList,
      metals,
    );
    return withCountryName(sellRateList, countryNames);
  }, [sellRateList, buyRateList, metals]);

  const filteredRows = useMemo(
    () => filterMetalRateRows(rows, search),
    [rows, search],
  );

  const columns = useMemo(
    () => [
      metalNameColumn,
      countryColumn,
      stateColumn,
      karatColumn(true),
      purityColumn,
      rateTypeColumn,
      ratePerGramColumn,
      taxColumn(taxType === "VAT" ? "TAX" : "GST"),
      rateWithGstColumn(taxType === "VAT" ? "Rate With Tax" : "Rate With GST"),
      updatedByColumn,
      dateColumn({
        field: "createdAt",
        headerName: "Applicable From",
        dateFormat: "DD-MMM-YYYY hh:mm A",
      }),
    ],
    [taxType],
  );

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>
          {error}
        </Alert>
      )}
      <MetalRateGrid
        title={title}
        rows={filteredRows}
        columns={columns}
        loading={loading}
        search={search}
        onSearchChange={(value) => {
          setSearch(value);
          setPage(0);
        }}
        page={page}
        onPageChange={setPage}
        pageSize={pageSize}
        onPageSizeChange={(size) => {
          setPageSize(size);
          setPage(0);
        }}
      />
    </Box>
  );
};

export default MetalRateSellTable;
